export default __webpack_public_path__ + "static/media/white-line-measure-icon.a6cecb67.svg";